import script from "./AdminHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminHome.vue?vue&type=script&setup=true&lang=ts"

import "./AdminHome.vue?vue&type=style&index=0&id=d7e3bf5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7e3bf5c"]])

export default __exports__